import type {LanguageSupportActions} from 'src/action-creators/language-support';
import {RECEIVE_CORPORATE_LABELS} from 'src/action-creators/language-support';


export type State = {
  corporateLabels: {
    [key: string]: string;
  } | null;
};

const initialState = {
  corporateLabels: null,
} as const;

export default (
  state: State = initialState,
  action: LanguageSupportActions,
): State => {
  switch (action.type) {
    case RECEIVE_CORPORATE_LABELS: {
      return {
        ...state,
        corporateLabels: action.payload.corporateLabels,
      };
    }
  }

  return state;
};
